import { commonRoutes } from '@didaskill/ui/domain';

export default {
  ...commonRoutes,
  // Routes below are for the unauthenticated user
  STUDENT: {
    ROOT: '/:studentId/:courseId',
    EMPTY: '/empty',
  },
} as const;
